import { useDocFlowContext } from '../../../../DocFlow.hooks'
import {
  getDocFlowSendingEmailContentFieldsProps,
  getDocFlowSendingEmilContentNotificationFileLimit,
  isDocFlowSendingEmailContentAvailablePreview,
  isDocFlowSendingEmailContentAvailableTestVariables,
  isDocFlowSendingEmailContentFileLimit,
} from '../../DocFlowSendingEmailContent.utils'

export function useDocFlowEmailFormFieldsProps() {
  const { phaseDisabled } = useDocFlowContext()

  const fieldsProps = getDocFlowSendingEmailContentFieldsProps(phaseDisabled)

  const fileUploadLimitProps = {
    isFileLimit: isDocFlowSendingEmailContentFileLimit,
    notification: getDocFlowSendingEmilContentNotificationFileLimit(),
  }

  const formFieldsProps = {
    PriorityFieldComponent: null,
    isAvailablePreview: isDocFlowSendingEmailContentAvailablePreview,
    isAvailableTestVariables:
      isDocFlowSendingEmailContentAvailableTestVariables,
    isFilesAsLinksEnabled: false,
  }

  return {
    fieldsProps,
    fileUploadLimitProps,
    formFieldsProps,
  }
}
